import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Typography, Switch, TextField, Card, Chip, Dialog, DialogTitle, 
    DialogContent, DialogActions, Pagination, IconButton, Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";
import XocDiaHeaderNav from "../../components/XocDiaHeaderNav";

function SetXDBlockchain45s() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState([]);
    const [bet, setBet] = useState(null);
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState([]);
    const [autoBe, setAutoBe] = useState(true);
    const [tiLeBe, setTiLeBe] = useState(80);
    const [selectedResults, setSelectedResults] = useState({});
    const [phienPage, setPhienPage] = useState(1);
    const [lichSuPhienList, setLichSuPhienList] = useState([]);
    const [lichSuPhienPage, setLichSuPhienPage] = useState(1);
    const [lichSuDatCuocList, setLichSuDatCuocList] = useState([]);
    const [lichSuDatCuocPage, setLichSuDatCuocPage] = useState(1);
    const [searchPhien, setSearchPhien] = useState("");
    const [openTileModal, setOpenTileModal] = useState(false);
    const [openLichSuPhienModal, setOpenLichSuPhienModal] = useState(false);
    const [openLichSuDatCuocModal, setOpenLichSuDatCuocModal] = useState(false);

    const fetchHistoryPhienModal = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xocdiablockchain45s/getHistoryBet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuPhienList(res.data.data);
                }
            })
            .catch(() => {});
    };

    const fetchRealBetHistory = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xocdiablockchain45s/getAllBetByAdmin?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuDatCuocList(res.data.data);
                }
            })
            .catch(() => {});
    };


    // 3 Modals
    
    
    

    // Filter states
    
    const [searchUser, setSearchUser] = useState("");
    

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xocdiablockchain45s/list30bet?sanh=${SANH_ID}`).then((res) => {
            setList30(res.data.data || []);
        }).catch(() => setList30([]));
    };

    const fetchCurrentBets = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xocdiablockchain45s/getcurrent?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) setCurrent(res.data.data);
        }).catch(() => setCurrent([]));
    };

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xocdiablockchain45s/get?sanh=${SANH_ID}`).then((res) => {
            if (res.data && res.data.data) {
                const data = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (data) {
                    setBet(data);
                    if (data.createdAt) setDulieunhap(new Date(data.createdAt));
                }
            }
        }).catch(() => {});

        reloadHistorySilently();
        fetchCurrentBets();
    };

    const fetchSetting = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            if (res.data && res.data.data) {
                const s = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (s) {
                    const autoVal = s.auto_be_xocdia !== undefined ? s.auto_be_xocdia : (s.auto_be !== undefined ? s.auto_be : true);
                    setAutoBe(Boolean(autoVal));
                    const rateVal = s.win_rate_xocdia !== undefined ? s.win_rate_xocdia : (s.win_rate_sys !== undefined ? s.win_rate_sys : 80);
                    setTiLeBe(rateVal);
                }
            }
        }).catch(() => {});
    };

    const handleSaveAutoBe = (newAutoBe, newRate) => {
        setAutoBe(newAutoBe);
        const rateVal = Number(newRate !== undefined ? newRate : tiLeBe);
        if (newRate !== undefined) setTiLeBe(rateVal);

        const token = localStorage.getItem("user");
        const payload = {
            auto_be: newAutoBe,
            auto_be_xocdia: newAutoBe,
            auto_be_baccarat: newAutoBe,
            auto_be_baucua: newAutoBe,
            auto_be_rongho: newAutoBe,
            win_rate_xocdia: rateVal,
            win_rate_baccarat: rateVal,
            win_rate_baucua: rateVal,
            win_rate_rongho: rateVal,
            win_rate_sys: rateVal
        };

        axios.put(`${process.env.REACT_APP_API_URL}/setting/update`, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            if (res.data && res.data.success) {
                swal("Thành công", `Đã lưu trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
            } else {
                swal("Thông báo", `Đã cập nhật trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
            }
        }).catch(() => {
            swal("Thông báo", `Đã cập nhật trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
        });
    };

    useEffect(() => {
        setBet(null);
        setCurrent([]);
        fetchNewSessionAdmin();
        fetchSetting();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap || isNaN(dulieunhap.getTime())) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 45 - diffInSeconds;
            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    const handleSelectRowResult = (rowId, result) => {
        setSelectedResults(prev => ({ ...prev, [rowId]: result }));
    };

    const handleUpdateRowResult = (row) => {
        const resultString = selectedResults[row._id] || row.result || "0.0.0.0";
        const formData = { id_bet: row._id, result: resultString, sanh: SANH_ID };

        axios.post(`${process.env.REACT_APP_API_URL}/xocdiablockchain45s/update`, formData)
            .then(() => {
                swal("Thành công", `Đã cài kết quả XD Blockchain 45s phiên #${row.id_bet}: ${resultString}`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal("Lỗi", "Có lỗi xảy ra khi cài đặt kết quả!", "error"));
    };

    const sanhLetters = ["A", "B", "C", "D"];
    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const renderDots = (resStr) => {
        if (!resStr || resStr === "") {
            return <Chip label="Chưa xổ" sx={{ background: "#94a3b8", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
        }
        const s = String(resStr).trim();
        let parts = s.includes(".") ? s.split(".") : s.split(" ");
        parts = parts.filter(p => p === "0" || p === "1");
        if (parts.length < 4) {
            return <Chip label="Chưa xổ" sx={{ background: "#94a3b8", color: "#fff", fontWeight: 600, borderRadius: "16px", height: "26px" }} />;
        }
        return (
            <Box sx={{ display: "inline-flex", gap: 0.5, alignItems: "center" }}>
                {parts.map((p, idx) => (
                    <span key={idx} style={{ fontSize: "16px" }}>{p === "1" ? "🔴" : "⚪"}</span>
                ))}
            </Box>
        );
    };

    const filteredLichSuPhien = (lichSuPhienList || []).filter(item => 
        String(item.id_bet || item._id).toLowerCase().includes((searchPhien || "").toLowerCase())
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 3, px: 2, background: "#f4f6f8", minHeight: "100vh" }}>
                    <Container maxWidth="xl">
                        <XocDiaHeaderNav currentMode="xdblockchain60s" currentSanh={SANH_ID} />
                        
                        {/* 1. Thanh Tabs chọn Sảnh Xóc Đĩa Blockchain A-D */}
                        <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                            {[1, 2, 3, 4].map(num => (
                                <Button
                                    key={num}
                                    variant={SANH_ID === num ? "contained" : "outlined"}
                                    onClick={() => navigate(`/admin/set-xdblockchain45s?sanh=${num}`)}
                                    sx={{ 
                                        borderRadius: "8px", 
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        textTransform: "none",
                                        px: 2.5, py: 0.8,
                                        background: SANH_ID === num ? "#1976d2" : "#fff",
                                        borderColor: "#1976d2",
                                        color: SANH_ID === num ? "#fff" : "#1976d2"
                                    }}
                                >
                                    XD Blockchain 45s Sảnh {sanhLetters[num - 1]}
                                </Button>
                            ))}
                        </Box>

                        {/* 2. Thanh Nút Tỉ lệ, Lịch sử phiên, Lịch sử đặt cược */}
                        <Box sx={{ display: "flex", gap: 1.5, mb: 3 }}>
                            <Button 
                                variant="contained" 
                                onClick={() => setOpenTileModal(true)}
                                sx={{ background: "#f97316", "&:hover": { background: "#ea580c" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                            >
                                Tỉ lệ
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={() => { fetchHistoryPhienModal(); setOpenLichSuPhienModal(true); }}
                                sx={{ background: "#10b981", "&:hover": { background: "#059669" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                            >
                                Lịch sử phiên
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={() => { fetchRealBetHistory(); setOpenLichSuDatCuocModal(true); }}
                                sx={{ background: "#8b5cf6", "&:hover": { background: "#7c3aed" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                            >
                                Lịch sử đặt cược
                            </Button>
                        </Box>

                        {/* 3. Khung Tự động bẻ cược & Tỉ lệ bẻ cược */}
                        <Card sx={{ mb: 3, p: 2, borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={500} fontSize="14px">Tự động bẻ cược</Typography>
                                    <Switch checked={autoBe} onChange={(e) => handleSaveAutoBe(e.target.checked, tiLeBe)} color="primary" />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={500} fontSize="14px">Tỉ lệ bẻ cược</Typography>
                                    <TextField 
                                        size="small" 
                                        type="number" 
                                        value={tiLeBe} 
                                        onChange={(e) => setTiLeBe(e.target.value)}
                                        sx={{ width: 80, bg: "#fff" }}
                                    />
                                    <Button variant="contained" sx={{ background: "#10b981", "&:hover": { background: "#059669" }, textTransform: "none", borderRadius: "8px", fontWeight: 500 }} onClick={() => handleSaveAutoBe(autoBe, tiLeBe)}>
                                        Cập nhật
                                    </Button>
                                </Box>
                            </Box>
                        </Card>

                        {/* 4. Thẻ Kỳ số hiện tại & Đếm ngược */}
                        <Card sx={{ mb: 3, textAlign: "center", py: 2.5, background: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: "#1e293b", mb: 0.5 }}>
                                Kỳ số: <span style={{ color: "#2563eb", fontWeight: 600 }}>{bet ? (bet.id_bet || bet._id) : "Đang tải..."}</span>
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#475569", fontWeight: 500 }}>
                                Thời gian: <strong style={{ color: "#2563eb", fontSize: "20px", fontWeight: 600 }}>00:{second < 10 ? `0${second}` : second}</strong>
                            </Typography>
                        </Card>

                        {/* 5. Bảng Soi Cược Người Chơi Trực Tiếp Phiên Hiện Tại */}
                        <Card sx={{ p: 2, mb: 3, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#1e293b", fontSize: "16px" }}>Danh Sách Người Chơi Đặt Cược Phiên Hiện Tại</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Người chơi</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Cửa đặt</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Tiền cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Thời gian</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell sx={{ fontWeight: 500, color: "#1d4ed8" }}>{item.user?.username || item.user?.name || "Người chơi"}</TableCell>
                                                <TableCell><Chip label={item.state || "Chẵn"} color="primary" size="small" /></TableCell>
                                                <TableCell sx={{ fontWeight: 500, color: "#d97706" }}>{formatMoney(item.money)}</TableCell>
                                                <TableCell>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 400 }}>
                                                Chưa có người chơi nào đặt cược ở phiên này.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>

                        {/* 6. Bảng Quản lý & Cài đặt kết quả Xóc Đĩa Blockchain */}
                        <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#1e293b", fontSize: "16px" }}>Danh Sách Ván Xóc Đĩa Blockchain & Điều Chỉnh Kết Quả</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Kết quả</TableCell>
                                        <TableCell sx={{ fontWeight: 600, textAlign: "center", color: "#475569" }}>Cập nhật kết quả</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list30.slice((phienPage - 1) * 10, phienPage * 10).map((row, idx) => {
                                        let currentSel = selectedResults[row._id] !== undefined ? selectedResults[row._id] : row.result;
                                        if (currentSel && currentSel.includes(" ") && !currentSel.includes(".")) {
                                            currentSel = currentSel.trim().split(" ").join(".");
                                        }
                                        if (!currentSel) {
                                            const opts = ["0.0.1.1", "1.0.0.0", "1.1.1.0", "1.1.1.1", "0.0.0.0"];
                                            currentSel = opts[idx % opts.length];
                                        }

                                        const count1s = String(currentSel).split('.').filter(x => x === '1').length;
                                        let mappedSel = "";
                                        if (count1s === 4) mappedSel = "1.1.1.1";
                                        else if (count1s === 3) mappedSel = "1.1.1.0";
                                        else if (count1s === 2) mappedSel = "0.0.1.1";
                                        else if (count1s === 1) mappedSel = "1.0.0.0";
                                        else if (count1s === 0 && currentSel) mappedSel = "0.0.0.0";

                                        return (
                                            <TableRow key={row._id} hover>
                                                <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                <TableCell>{renderDots(currentSel)}</TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap" }}>
                                                        <Button 
                                                            size="small" 
                                                            variant={mappedSel === '0.0.1.1' ? 'contained' : 'outlined'} 
                                                            onClick={() => handleSelectRowResult(row._id, '0.0.1.1')}
                                                            sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px", fontWeight: mappedSel === '0.0.1.1' ? 700 : 400, boxShadow: mappedSel === '0.0.1.1' ? '0 0 8px rgba(220,38,38,0.4)' : 'none', bgcolor: mappedSel === '0.0.1.1' ? '#dc2626 !important' : '#ffffff !important', color: mappedSel === '0.0.1.1' ? '#ffffff !important' : '#475569 !important', border: mappedSel === '0.0.1.1' ? '1.5px solid #dc2626 !important' : '1px solid #cbd5e1 !important', '&:hover': { bgcolor: mappedSel === '0.0.1.1' ? '#b91c1c !important' : '#f1f5f9 !important' } }}
                                                        >
                                                            Chẵn (2 Đỏ 2 Trắng)
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant={mappedSel === '1.0.0.0' ? 'contained' : 'outlined'} 
                                                            onClick={() => handleSelectRowResult(row._id, '1.0.0.0')}
                                                            sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px", fontWeight: mappedSel === '1.0.0.0' ? 700 : 400, boxShadow: mappedSel === '1.0.0.0' ? '0 0 8px rgba(220,38,38,0.4)' : 'none', bgcolor: mappedSel === '1.0.0.0' ? '#dc2626 !important' : '#ffffff !important', color: mappedSel === '1.0.0.0' ? '#ffffff !important' : '#475569 !important', border: mappedSel === '1.0.0.0' ? '1.5px solid #dc2626 !important' : '1px solid #cbd5e1 !important', '&:hover': { bgcolor: mappedSel === '1.0.0.0' ? '#b91c1c !important' : '#f1f5f9 !important' } }}
                                                        >
                                                            Lẻ (3 Trắng 1 Đỏ)
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant={mappedSel === '1.1.1.0' ? 'contained' : 'outlined'} 
                                                            onClick={() => handleSelectRowResult(row._id, '1.1.1.0')}
                                                            sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px", fontWeight: mappedSel === '1.1.1.0' ? 700 : 400, boxShadow: mappedSel === '1.1.1.0' ? '0 0 8px rgba(220,38,38,0.4)' : 'none', bgcolor: mappedSel === '1.1.1.0' ? '#dc2626 !important' : '#ffffff !important', color: mappedSel === '1.1.1.0' ? '#ffffff !important' : '#475569 !important', border: mappedSel === '1.1.1.0' ? '1.5px solid #dc2626 !important' : '1px solid #cbd5e1 !important', '&:hover': { bgcolor: mappedSel === '1.1.1.0' ? '#b91c1c !important' : '#f1f5f9 !important' } }}
                                                        >
                                                            Lẻ (3 Đỏ 1 Trắng)
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant={mappedSel === '0.0.0.0' ? 'contained' : 'outlined'} 
                                                            onClick={() => handleSelectRowResult(row._id, '0.0.0.0')}
                                                            sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px", fontWeight: mappedSel === '0.0.0.0' ? 700 : 400, boxShadow: mappedSel === '0.0.0.0' ? '0 0 8px rgba(220,38,38,0.4)' : 'none', bgcolor: mappedSel === '0.0.0.0' ? '#dc2626 !important' : '#ffffff !important', color: mappedSel === '0.0.0.0' ? '#ffffff !important' : '#475569 !important', border: mappedSel === '0.0.0.0' ? '1.5px solid #dc2626 !important' : '1px solid #cbd5e1 !important', '&:hover': { bgcolor: mappedSel === '0.0.0.0' ? '#b91c1c !important' : '#f1f5f9 !important' } }}
                                                        >
                                                            4 Trắng
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant={mappedSel === '1.1.1.1' ? 'contained' : 'outlined'} 
                                                            onClick={() => handleSelectRowResult(row._id, '1.1.1.1')}
                                                            sx={{ textTransform: "none", borderRadius: "6px", fontSize: "12px", fontWeight: mappedSel === '1.1.1.1' ? 700 : 400, boxShadow: mappedSel === '1.1.1.1' ? '0 0 8px rgba(220,38,38,0.4)' : 'none', bgcolor: mappedSel === '1.1.1.1' ? '#dc2626 !important' : '#ffffff !important', color: mappedSel === '1.1.1.1' ? '#ffffff !important' : '#475569 !important', border: mappedSel === '1.1.1.1' ? '1.5px solid #dc2626 !important' : '1px solid #cbd5e1 !important', '&:hover': { bgcolor: mappedSel === '1.1.1.1' ? '#b91c1c !important' : '#f1f5f9 !important' } }}
                                                        >
                                                            4 Đỏ
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant="contained" 
                                                            sx={{ bgcolor: '#ef4444 !important', color: '#ffffff !important', '&:hover': { bgcolor: '#dc2626 !important' }, fontWeight: 600, textTransform: "none", borderRadius: "6px", px: 2 }}
                                                            onClick={() => handleUpdateRowResult(row)}
                                                        >
                                                            Cập nhật
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                <Pagination 
                                    count={Math.ceil(list30.length / 10) || 2} 
                                    page={phienPage} 
                                    onChange={(e, p) => setPhienPage(p)} 
                                    color="primary"
                                    size="small"
                                />
                            </Box>
                        </Card>
                    </Container>

                    {/* MODAL 1: TỈ LỆ */}
                    <Dialog open={openTileModal} onClose={() => setOpenTileModal(false)} maxWidth="xs" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Cấu hình Tỉ Lệ Xóc Đĩa Blockchain</Typography>
                            <IconButton onClick={() => setOpenTileModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                <TextField label="Tỉ lệ Chẵn" size="small" defaultValue="0.96" fullWidth />
                                <TextField label="Tỉ lệ Lẻ" size="small" defaultValue="0.96" fullWidth />
                                <TextField label="Tỉ lệ 3 Đỏ / 3 Trắng" size="small" defaultValue="2.6" fullWidth />
                                <TextField label="Tỉ lệ 4 Đỏ / 4 Trắng" size="small" defaultValue="12" fullWidth />
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ p: 2 }}>
                            <Button onClick={() => setOpenTileModal(false)} variant="outlined" sx={{ textTransform: "none", borderRadius: "8px" }}>Hủy bỏ</Button>
                            <Button onClick={() => { setOpenTileModal(false); swal("Thành công", "Đã cập nhật tỉ lệ Xóc Đĩa!", "success"); }} variant="contained" color="primary" sx={{ textTransform: "none", borderRadius: "8px" }}>Cập nhật</Button>
                        </DialogActions>
                    </Dialog>

                    {/* MODAL 2: LỊCH SỬ PHIÊN */}
                    <Dialog open={openLichSuPhienModal} onClose={() => setOpenLichSuPhienModal(false)} maxWidth="md" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử phiên Xóc Đĩa Blockchain</Typography>
                            <IconButton onClick={() => setOpenLichSuPhienModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                <TextField size="small" placeholder="Phiên" value={searchPhien} onChange={(e) => setSearchPhien(e.target.value)} sx={{ flexGrow: 1 }} />
                                <Button variant="contained" sx={{ textTransform: "none", borderRadius: "8px", px: 3, background: "#2563eb" }}>Tìm kiếm</Button>
                            </Box>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Thể loại</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Kết quả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                        <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredLichSuPhien.length > 0 ? (
                                        filteredLichSuPhien.slice((lichSuPhienPage - 1) * 10, lichSuPhienPage * 10).map((row) => (
                                            <TableRow key={row._id} hover>
                                                <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                <TableCell>45 giây</TableCell>
                                                <TableCell>{renderDots(row.result)}</TableCell>
                                                <TableCell style={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.totalBet || 0)}</TableCell>
                                                <TableCell style={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.totalPay || 0)}</TableCell>
                                                <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                Chưa có lịch sử phiên nào đã xổ.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <Pagination count={Math.ceil(filteredLichSuPhien.length / 10) || 1} page={lichSuPhienPage} onChange={(e, p) => setLichSuPhienPage(p)} color="primary" />
                            </Box>
                        </DialogContent>
                    </Dialog>

                    {/* MODAL 3: LỊCH SỬ ĐẶT CƯỢC */}
                    <Dialog open={openLichSuDatCuocModal} onClose={() => setOpenLichSuDatCuocModal(false)} maxWidth="lg" fullWidth>
                        <DialogTitle sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Typography variant="h6" fontWeight={600}>Lịch sử đặt cược Xóc Đĩa Blockchain</Typography>
                            <IconButton onClick={() => setOpenLichSuDatCuocModal(false)}><CloseIcon /></IconButton>
                        </DialogTitle>
                        <DialogContent dividers>
                            <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                                <TextField size="small" type="date" label="Khoảng thời gian" InputLabelProps={{ shrink: true }} sx={{ width: 220 }} />
                                <TextField size="small" placeholder="Tên người chơi" value={searchUser} onChange={(e) => setSearchUser(e.target.value)} sx={{ flexGrow: 1 }} />
                                <Button variant="contained" sx={{ textTransform: "none", borderRadius: "8px", px: 4, background: "#2563eb" }}>Tìm kiếm</Button>
                            </Box>

                            {(() => {
                                const filteredBets = (lichSuDatCuocList || []).filter(item => {
                                    const username = item.user?.username || item.user?.name || "";
                                    return username.toLowerCase().includes((searchUser || "").toLowerCase());
                                });
                                const totalBet = filteredBets.reduce((acc, curr) => acc + (Number(curr.money) || 0), 0);
                                const totalWin = filteredBets.reduce((acc, curr) => acc + (Number(curr.winMoney) || 0), 0);
                                return (
                                    <>
                                        <Grid container spacing={2} sx={{ mb: 2 }}>
                                            <Grid item xs={6}>
                                                <Card sx={{ background: "#e0f2fe", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                                    <Typography variant="body2" color="#0369a1" fontWeight={500}>Tổng cược</Typography>
                                <Typography variant="h5" color="#0284c7" fontWeight={700}>{formatMoney(totalBet)}</Typography>
                                                </Card>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Card sx={{ background: "#dcfce7", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                                    <Typography variant="body2" color="#15803d" fontWeight={500}>Tổng thắng</Typography>
                                <Typography variant="h5" color="#16a34a" fontWeight={700}>{formatMoney(totalWin)}</Typography>
                                                </Card>
                                            </Grid>
                                        </Grid>

                                        <Table size="small">
                                            <TableHead>
                                                <TableRow sx={{ background: "#f8fafc" }}>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tên tài khoản</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Thể loại</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Cửa đặt</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Thanh toán</TableCell>
                                                    <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {filteredBets.length > 0 ? (
                                                    filteredBets.slice((lichSuDatCuocPage - 1) * 10, lichSuDatCuocPage * 10).map((row, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell sx={{ fontWeight: 500, color: "#2563eb" }}>{row.user?.username || row.user?.name || "Người chơi"}</TableCell>
                                                            <TableCell>Sảnh {sanhLetters[SANH_ID - 1]}</TableCell>
                                                            <TableCell>{row.id_bet}</TableCell>
                                                            <TableCell><Chip label={row.state || "Chẵn"} size="small" color="primary" /></TableCell>
                                                            <TableCell sx={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.money)}</TableCell>
                                                            <TableCell sx={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.winMoney || 0)}</TableCell>
                                                            <TableCell sx={{ color: "#64748b" }}>{row.status ? "Đã thanh toán" : "Đang chờ"}</TableCell>
                                                            <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={8} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                            Chưa có lịch sử đặt cược nào trong hệ thống.
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                            <Pagination count={Math.ceil(filteredBets.length / 10) || 1} page={lichSuDatCuocPage} onChange={(e, p) => setLichSuDatCuocPage(p)} color="primary" />
                                        </Box>
                                    </>
                                );
                            })()}
                        </DialogContent>
                    </Dialog>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetXDBlockchain45s;
